export enum LoaderType {
  FULL_SCREEN,
  EMBEDDED,
  INLINE,
  INLINE_TEXT,
}
